(() => {
  if (customElements.get('kt-faq-accordion')) return;

  class KtFaqAccordion extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.animations = new Map();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.events.signal };

      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.ktfaq-item > summary');
        if (!summary || !this.contains(summary) || !summary.parentElement.animate) return;
        event.preventDefault();
        const details = summary.parentElement;
        const current = this.animations.get(details);
        this.setExpanded(details, !(current ? current.expanded : details.open));
      }, options);

      this.addEventListener('keydown', (event) => {
        const details = event.target.closest('.ktfaq-item');
        if (event.key !== 'Escape' || !details || !details.open) return;
        event.preventDefault();
        details.querySelector('summary').focus({ preventScroll: true });
        this.setExpanded(details, false);
      }, options);

      // A viewport or motion-preference change must never leave a fixed height behind.
      window.addEventListener('resize', () => this.finishAll(), options);
      this.reducedMotion.addEventListener('change', () => this.finishAll(), options);
      this.addEventListener('toggle', (event) => {
        if (this.animations.has(event.target) && !event.target.open) {
          this.finish(event.target, false);
        }
      }, { ...options, capture: true });
    }

    setExpanded(details, expanded) {
      const from = details.getBoundingClientRect().height;
      const previous = this.animations.get(details);
      if (previous) {
        previous.animation.onfinish = null;
        previous.animation.cancel();
        this.animations.delete(details);
      }

      if (this.reducedMotion.matches) {
        this.finish(details, expanded);
        return;
      }

      // Measure the natural destination, then keep the answer rendered until closing ends.
      details.open = expanded;
      const to = details.getBoundingClientRect().height;
      details.open = true;
      details.dataset.faqAnimating = '';
      details.dataset.faqExpanded = String(expanded);
      const animation = details.animate(
        [{ height: `${from}px` }, { height: `${to}px` }],
        { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'both' }
      );
      this.animations.set(details, { animation, expanded });
      animation.onfinish = () => {
        if (this.animations.get(details)?.animation === animation) {
          this.finish(details, expanded);
        }
      };
    }

    finish(details, expanded) {
      const current = this.animations.get(details);
      this.animations.delete(details);
      details.open = expanded;
      if (current) {
        current.animation.onfinish = null;
        current.animation.cancel();
      }
      delete details.dataset.faqAnimating;
      delete details.dataset.faqExpanded;
    }

    finishAll() {
      for (const [details, state] of this.animations) this.finish(details, state.expanded);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.finishAll();
      this.events = null;
    }
  }

  customElements.define('kt-faq-accordion', KtFaqAccordion);
})();
